module.exports = __webpack_public_path__ + "images/topics/coral-reef/coralreef_seagrass.png";